import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { BRANCH_DATE, BRANCH_NAME, BRANCH_NUMBER, BRANCH_VERSION, ENV, SENTRY_DNS } from 'settings';
import store from 'store';
import { enEnviroment } from 'types/enums';

import App from './App';

console.log(
  `(sun-admin-front-v3) Version: ${BRANCH_NUMBER} / Branch: ${BRANCH_NAME} / Commit: ${BRANCH_VERSION} / Date: ${BRANCH_DATE} `
);

if (ENV !== enEnviroment.DEV) {
  Sentry.init({
    dsn: SENTRY_DNS,
    integrations: [new BrowserTracing()],
    debug: ENV === enEnviroment.HOMOLOG,
    release: `${BRANCH_NUMBER}:${BRANCH_VERSION}`,
    environment: ENV,
    tracesSampleRate: ENV === enEnviroment.HOMOLOG ? 1.0 : 0.2,
    attachStacktrace: true
  });
}
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
ReactDOM.createRoot(document.getElementById('root')!).render(
  <BrowserRouter>
    <Provider store={store}>
      <App />
    </Provider>
  </BrowserRouter>
);
